import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {CartDetailRoutingModule} from './cart-detail-routing.module';
import {CartDetailComponent} from './cart-detail.component';
import {AppBarModule} from "@app/presentation/components/app-bar/app-bar.module";
import {CartSummaryComponent} from './cart-summary/cart-summary.component';
import {ButtonModule} from "@app/presentation/components/button/button.module";
import {ProductListModule} from "@app/presentation/components/product-list/product-list.module";
import {TranslateModule} from "@ngx-translate/core";
import {PromotionDetailModule} from "@app/presentation/pages/promotion-detail/promotion-detail.module";
import {ItemTileModule} from "@app/presentation/components/item-tile/item-tile.module";
import {LocalizedCurrencyModule} from "@app/presentation/pipes/localized-currency/localized-currency.module";
import {SimilarProductsModule} from "@app/presentation/components/similar-products/similar-products.module";
import {LocalizedDecimalModule} from "@app/presentation/pipes/localized-decimal/localized-decimal.module";
import {EmptyCartComponent} from './empty-cart/empty-cart.component';
import {LocalizeRouterModule} from "@gilsdav/ngx-translate-router";
import {PromotionListComponent} from "@app/presentation/components/promotion-list/promotion-list.component";
import {SvgIconComponent} from "angular-svg-icon";


@NgModule({
  declarations: [
    CartDetailComponent,
    CartSummaryComponent,
    EmptyCartComponent,
  ],
    imports: [
        CommonModule,
        CartDetailRoutingModule,
        AppBarModule,
        ButtonModule,
        ProductListModule,
        TranslateModule,
        PromotionDetailModule,
        ItemTileModule,
        LocalizedCurrencyModule,
        SimilarProductsModule,
        LocalizedDecimalModule,
        LocalizeRouterModule,
        PromotionListComponent,
        SvgIconComponent,
    ]
})
export class CartDetailModule { }
